/**
 * Initializes i18next, react-i18next, and the LanguageDetector.
 *
 * The language is set accourding to the following heirarchy:
 * - If current_user.language is set, use it.
 * - If not, use LanguageDetector (query string, cached values, navigator, html tag, path, subdomain).
 *
 * When a given translation key is not found in the primary language, i18next falls back to:
 * - Other manually set UserLanguages
 * - TODO: User's country's language
 * - English
 * - If no key is found still, the key itself is rendered.
 *
 */

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { currentUser } from 'js/utils/user';
import { LocaleCode, BASE_LOCALE } from 'js/i18next/i18n.d';
import assignGlobal from 'app/assets/webpack_entry/util/assign_global.wjs';
import { Aedu } from 'global';

// Set in app/views/layouts/_dependencies.html.erb
// (must be set manually for routes use the 'simple' layouts)
// When false will disable translation and fallback exclusively to English
const enableLocalization = Aedu.enableLocalization;

const debug = window.$rails_env === 'development';
let defaultLanguage: LocaleCode | undefined;

if (currentUser && enableLocalization) {
  defaultLanguage = currentUser.language;
}

const initPromise = i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug,
    lng: defaultLanguage,
    fallbackLng: BASE_LOCALE,
    supportedLngs: enableLocalization ? false : [BASE_LOCALE],
    initImmediate: false,
    nsSeparator: ':',
    defaultNS: 'Global',
    fallbackNS: 'Global',
    keySeparator: '.',
    // resources are added later via addResources()
    resources: {},
    // Uses language code only, ex. 'en' rather than 'en-US'
    // LanguageDetector will still detect 'en-US', but 'en' is prepended to i18next.language
    load: 'languageOnly',
    react: { useSuspense: false },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

assignGlobal('Aedu', { i18next });

export { initPromise, i18next };
